"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { Component } from "react";
import Tooltip from "./Tooltip";
import { observable } from "mobx";
import { observer } from "mobx-react";
const ErrorTooltipTimeout = 3500;
const withErrorTimeout = (WrappedTooltip) => {
  let WithErrorTimeout = class extends Component {
    constructor() {
      super(...arguments);
      this.showTooltip = false;
      this.tooltipTimeout = null;
    }
    componentDidMount() {
      this.showTooltip = true;
      this.tooltipTimeout = setTimeout(() => {
        this.showTooltip = false;
      }, ErrorTooltipTimeout);
    }
    componentWillUnmount() {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
    }
    render() {
      const { props } = this;
      return /* @__PURE__ */ React.createElement(WrappedTooltip, __spreadValues({ isError: true, show: this.showTooltip }, props));
    }
  };
  __decorateClass([
    observable.ref
  ], WithErrorTimeout.prototype, "showTooltip", 2);
  WithErrorTimeout = __decorateClass([
    observer
  ], WithErrorTimeout);
  return WithErrorTimeout;
};
const TooltipWithErrorTimeout = withErrorTimeout(Tooltip);
const ErrorTooltip = (props) => {
  const { children, renderTooltip } = props;
  return renderTooltip ? /* @__PURE__ */ React.createElement(TooltipWithErrorTimeout, __spreadValues({}, props)) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export default ErrorTooltip;
export { TooltipWithErrorTimeout, withErrorTimeout, ErrorTooltipTimeout };
